import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import AbstractListenerAction from "~/ts/library/listen/AbstractListenerAction";

export default abstract class AbstractOperatorApplicationListener extends AbstractListenerAction {
    public onAction(payload: any) {
        if (OperatorAccountStore.operator.value) {
            this.receive(payload);
        }
    }

    protected abstract receive(payload: any): void;
}